export default __webpack_public_path__ + "static/media/src_img_6.51b59e98.png";